module.exports = __webpack_public_path__ + "static/media/map-marker-alt-slash.f9bacdeb.svg";